import { createIcon } from '../utils';

export const ZoomIcon = createIcon(
  ({ ref, className, width = 26, height = 26, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="13" cy="13" r="13" fill="#E5E7EB" stroke="none" />
      <path
        d="M19.75 19.75L16.4875 16.4875M12.25 10V14.5M10 12.25H14.5M18.25 12.25C18.25 15.5637 15.5637 18.25 12.25 18.25C8.93629 18.25 6.25 15.5637 6.25 12.25C6.25 8.93629 8.93629 6.25 12.25 6.25C15.5637 6.25 18.25 8.93629 18.25 12.25Z"
        stroke="#4B5563"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'ZoomIcon',
  },
);
